/**
 * The public api for consumers of ngx-lottie
 */
export { LottieModule } from './lib/lottie.module';
export { LottieCacheModule } from './lib/cacheable-animation-loader/lottie-cache.module';
export { BaseDirective } from './lib/base.directive';
export { LottieDirective } from './lib/lottie.directive';
export { LottieComponent } from './lib/lottie.component';
export { LottieTransferState } from './lib/transfer-state';
export { transformAnimationFilenameToKey } from './lib/server';
//# sourceMappingURL=index.js.map